module.exports = __webpack_public_path__ + "static/img/antibriberyPolicy.20ee9b5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/antibriberyPolicy.pdf
// module id = gBxM
// module chunks = 62